import { TALKDESK_LOGO } from '../../constants/images'
import Image from '@talkdesk/cobalt-react-image'
import Flex from '@talkdesk/cobalt-react-flex'
import { useTranslation } from 'react-i18next'

const DisclaimerHeader = ({
  brandingSettings: {
    branding: { assets, name },
  },
}) => {
  const { t } = useTranslation()

  return (
    <Flex direction='column' alignX='center' paddingBottom={6}>
      {assets && (
        <Image
          src={TALKDESK_LOGO(assets)}
          alt={t('common.logoAlt', { name })}
          height={32}
          width={160}
        />
      )}
    </Flex>
  )
}

export default DisclaimerHeader
